<template>
  <div :class="$style.root">
    <slot />
  </div>
</template>

<script>

import arrayToggle from '@converdy/utils/array-toggle'

export default {
  name: 'ToggleButtonGroup',

  props: {
    size: String,
    exclusive: Boolean,
    conjoined: Boolean,
    value: {
      type: [ String, Array, Boolean ],
      required: true
    }
  },

  reactiveProvide: {
    name: 'ToggleButtonGroup',
    include: [
      'size',
      'value',
      'conjoined',
      'handleChange',
    ]
  },

  methods: {
    handleChange (value) {
      if (this.exclusive) {
        /*
         * TODO: 'input' should be deprecated since this is a change
         * it's still here since this would break things right now
         * remove after refactor
         */
        this.$emit('input', value)
        this.$emit('change', value)
      } else {
        this.$emit('input', arrayToggle(this.value, value))
        this.$emit('change', arrayToggle(this.value, value))
      }
    }
  }
}

</script>

<style module>

.root {
  display: inline-flex;
  justify-content: stretch;
}

</style>
